import React, { ReactElement, useEffect } from "react";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Button from "@mui/material/Button";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import { useDispatch, useSelector } from "react-redux";
import { AppState } from "../../reducers";
import { setIsOpen } from "../../actions/modalActions";
import { Grid } from "@mui/material";
import { t } from "i18next";
import { capitalizeFirstLetter } from "../../hooks/useCapitalized";
import { LOGOUT_API } from "../../utils/api";

const style = {
  alignItems: "center",
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  height: "276px !important",
  width: "432px !important",
  bgcolor: "#FFF",
  border: "1px solid #FFF",
  borderRadius: "12px",
  boxShadow: `0px 12px 40px 32px rgba(27, 27, 27, 0.12)`,
  py: "2%",
  px: "2%",
};

const LogoutModal: React.FC = (): ReactElement => {

  const [open, setOpen] = React.useState(false);

  const { isOpen } = useSelector((state: AppState) => state.modal);

  const { intl } = useSelector((state: AppState) => state.intl);

  const dispatch = useDispatch();

  useEffect(() => {
    setOpen(Boolean(isOpen));
  }, [isOpen]);

  const handleClose = () => {
    dispatch(setIsOpen(false));
  };

  const disconnect = async () => {
    try {
      await LOGOUT_API();
    } finally {
      window.location.replace("/");
    }
  };

  return (
    <div>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="parent-modal-title"
        aria-describedby="modal-description"
      >
        <Box sx={{ ...style, 
          textAlign: intl === 'ar' ? 'right' : 'left',
          width: 400, height: "auto" }} data-testid="modal-container">
          <ErrorOutlineIcon
            data-testid="close-icon"
            style={{
              alignItems: "center",
              backgroundColor: "#FA3434",
              borderRadius: "50px",
              color: "#FFF",
              padding: "14px",
              height: "32px",
              width: "32px",
            }}
          />

          <h2
            style={{
              color: "#1A0244",
              fontFamily: intl === 'ar' ? 'TheSansArab' : "Gellix",
              fontStyle: "normal",
              fontWeight: "700",
              fontSize: "20px",
              lineHeight: "28px",
            }}
            id="modal-title"
          >
            {t('txt.logout')}
          </h2>

          <p
            style={{
              color: "#524977",
              fontFamily: intl === 'ar' ? 'TheSansArab' : "Gellix",
              fontStyle: "normal",
              fontWeight: "500",
              fontSize: "16px",
              lineHeight: "24px",
            }}
            id="modal-description"
          >
            {t('ask.logout')}
          </p>
          <Grid
            item
            xs={12}
            spacing={2}
            style={{
              alignItems: "center",
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
            }}
          >
            <Button
              data-testid="cancel-button"
              style={{
                backgroundColor: "#FFF",
                border: "1px solid #C4C0D3",
                borderRadius: "4px",
                margin: "0",
                padding: "2% 5%",
                height: "42px",
                width: "48%",
              }}
              onClick={() => {
                handleClose();
              }}
            >
              <p
                style={{
                  color: "#1A0244",
                  fontFamily: intl === 'ar' ? 'TheSansArab' : "Gellix",
                  fontStyle: "normal",
                  fontWeight: "700",
                  fontSize: "17px",
                  lineHeight: "24px",
                  margin: "0",
                  padding: "0",
                  textTransform: "capitalize",
                }}
              >
                {capitalizeFirstLetter(String(t('cancel')))}
              </p>
            </Button>
            <Button
              data-testid="disconnect-button"
              style={{
                color: "#FFF",
                backgroundColor: "#FA3434",
                border: "1px solid #C4C0D3",
                borderRadius: "4px",
                margin: "0",
                padding: "2% 5%",
                height: "42px",
                width: "48%",
              }}
              onClick={disconnect}
            >
              <p
                style={{
                  color: "#FFF",
                  fontFamily: intl === 'ar' ? 'TheSansArab' : "Gellix",
                  fontStyle: "normal",
                  fontWeight: "700",
                  fontSize: "17px",
                  lineHeight: "24px",
                  margin: "0",
                  padding: "0",
                  textTransform: "capitalize",
                }}
              >
                {capitalizeFirstLetter(String(t('logout')))}{" "}
              </p>
            </Button>
          </Grid>
        </Box>
      </Modal>
    </div>
  );
};

export default LogoutModal;
